"use client";

import {
  SiteTemplatePageSectionTypeMissionAvatarImagesListItemSettingModel,
  SiteTemplatePageSectionTypeMissionItemsListItemSettingModel,
} from "@/Apis/ClinicApi";
import { Html } from "@/Components";
import { MissionSectionProps } from "@/Templates/SectionsProps";
import classNames from "classnames";
import { FC, ReactNode } from "react";
import HomeThreeMissionSectionGenerated, {
  HomeThreeMissionSectionGeneratedProps,
} from "../Sections/_generated/HomeThreeMissionSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

function renderHtmlValue(value?: string | null): ReactNode {
  if (!value) {
    return undefined;
  }

  return <Html value={value} />;
}

function getMissionItems(
  props: MissionSectionProps,
): SiteTemplatePageSectionTypeMissionItemsListItemSettingModel[] {
  return props.lists.Items ?? [];
}

function getAvatarItems(
  props: MissionSectionProps,
): SiteTemplatePageSectionTypeMissionAvatarImagesListItemSettingModel[] {
  return props.lists.AvatarImages ?? [];
}

const GeneratedMissionSection: FC<MissionSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeThreeMissionSectionGeneratedProps>(
      "HomeThreeMissionSection",
    );
  const missionItems = getMissionItems(props);
  const avatarItems = getAvatarItems(props);

  return (
    <HomeThreeMissionSectionGenerated
      {...defaults}
      sectionDiv0Div0Div0Div0Div0P0PText={
        props.setting.Title ?? defaults.sectionDiv0Div0Div0Div0Div0P0PText
      }
      sectionDiv0Div0Div0Div0H20H2Text={
        props.setting.Subtitle ?? defaults.sectionDiv0Div0Div0Div0H20H2Text
      }
      sectionDiv0Div0Div0Div0P0PText={
        renderHtmlValue(props.setting.Description) ??
        defaults.sectionDiv0Div0Div0Div0P0PText
      }
      sectionDiv0Div0Div0Div0P0Span0SpanText=""
      sectionDiv0Div0Div0Div0Div1Div1P0PText={
        props.setting.ClientsTitle ??
        defaults.sectionDiv0Div0Div0Div0Div1Div1P0PText
      }
      sectionDiv0Div0Div0Div0Div1Div1P0Span0SpanText={
        props.setting.ClientsSubtitle ??
        defaults.sectionDiv0Div0Div0Div0Div1Div1P0Span0SpanText
      }
      missionSectionMissionThrees={
        missionItems.length > 0
          ? missionItems.map((item, index) => {
              const baseItem =
                defaults.missionSectionMissionThrees[
                  index % defaults.missionSectionMissionThrees.length
                ] ?? defaults.missionSectionMissionThrees[0];

              return {
                ...baseItem,
                key: item.Id,
                h30Text: item.Title ?? baseItem?.h30Text ?? "",
                p0Text:
                  renderHtmlValue(item.Description) ?? baseItem?.p0Text ?? "",
                src: item.Image?.Url ?? baseItem?.src ?? "",
                alt:
                  item.Image?.AltText ??
                  item.Title ??
                  baseItem?.alt ??
                  "mission",
                className: classNames("mission-item-three", {
                  "mb-0": missionItems.length - 1 == index,
                }),
              };
            })
          : defaults.missionSectionMissionThrees
      }
      missionSectionAvatarAvatarRoundeds={
        avatarItems.length > 0
          ? avatarItems.map((item, index) => {
              const baseItem =
                defaults.missionSectionAvatarAvatarRoundeds[
                  index % defaults.missionSectionAvatarAvatarRoundeds.length
                ] ?? defaults.missionSectionAvatarAvatarRoundeds[0];

              return {
                ...baseItem,
                key: item.Id,
                src: item.Image?.Url ?? baseItem?.src ?? "",
                alt: item.Image?.AltText ?? baseItem?.alt ?? "avatar",
              };
            })
          : defaults.missionSectionAvatarAvatarRoundeds
      }
    />
  );
};

export default GeneratedMissionSection;
